export function editSignupListOption(postData) {
  console.log('postData.value', postData.value)
  return {
    isApp: false,
    success: true,
    userID: true,
    options: {
      notifyAdmins: postData.value
    }
  }
}